// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__KZI4t","loader":"loader_loader__7AeKQ","Table":"loader_Table__Jwbk0"};